import * as Yup from "yup";

const InsuranceCompanySchema = Yup.object().shape({
  name: Yup.string().required("Required"),
});

export default InsuranceCompanySchema;
